import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=d2a0de66&scoped=true&"
import script from "./UserPermissions.vue?vue&type=script&lang=js&"
export * from "./UserPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=d2a0de66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a0de66",
  null
  
)

export default component.exports